var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.195 8.03665L15.9633 5.80489C15.7029 5.54455 15.2808 5.54455 15.0204 5.8049L13.9045 6.92081L17.0791 10.0954L18.195 8.97946C18.4554 8.71911 18.4554 8.29699 18.195 8.03665Z",
    stroke: "#333333",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37267 18.4266L9.274 17.757C9.39574 17.7289 9.50714 17.6672 9.59549 17.5788L16.6079 10.5664C16.8683 10.3061 16.8683 9.88395 16.6079 9.6236L14.3761 7.39182C14.1158 7.13147 13.6937 7.13147 13.4333 7.39182L6.42089 14.4043C6.33254 14.4926 6.2708 14.604 6.2427 14.7258L5.57317 17.6271C5.46238 18.1071 5.89262 18.5374 6.37267 18.4266Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonEdit);
export default __webpack_public_path__ + "static/media/buttonEdit.ff9d6ba45ea5e620c2b26ba255ea516c.svg";
export { ForwardRef as ReactComponent };